<template>
  <v-progress-linear
    v-if="loading"
    color="primary"
    indeterminate
    reverse
  ></v-progress-linear>
  <div v-else>
    <v-row dense>
      <v-col v-for="(component, i) in content" :key="i" cols="12">
        <Section
          :key="i"
          v-if="component.type == '1-col-section'"
          :component="component"
          :index="i"
        />
        <TwoColSection
          :key="i"
          v-if="component.type == '2-col-section'"
          :component="component"
          :index="i"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import jsonLoader from "@/services/jsonParser";
import Section from "@/components/HomeSections/Section";
import TwoColSection from "@/components/HomeSections/TwoColSection";

export default {
  name: "Homepage",
  components: {
    Section,
    TwoColSection,
  },
  data() {
    return {
      content: null,
      loading: true,
    };
  },
  beforeMount() {
    jsonLoader("homepage").then((data) => {
      this.content = data;
      this.loading = false;
    });
  },
};
</script>
